module.exports = __webpack_public_path__ + "img/step4.9a4a8ff6.png";